import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function Countdown() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Seg'
  }];
  return <div className="flex items-start justify-center gap-2 md:gap-3" role="timer" aria-live="off" data-id="element-19" data-mp="3q0vr6xdo4ds4">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-20" data-mp="3c12xquarbjgg" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-21" data-mp="3h0z615qhlx1t">
            <span className="flex h-20 w-20 items-center justify-center rounded-2xl bg-brand text-4xl font-black tabular-nums text-white md:h-24 md:w-24 md:text-5xl" data-id="element-22" data-mp="3h1qpxjaq26c9">
              {String(u.value).padStart(2, '0')}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-widest text-muted" data-id="element-23" data-mp="374mdib6ohp8n">
              {u.label}
            </span>
          </div>
          {i < units.length - 1 && <span className="pt-5 text-3xl font-black text-brand md:pt-6 md:text-4xl" data-id="element-24" data-mp="15awlyvo0cit7">:</span>}
        </React.Fragment>)}
    </div>;
}